/**
 * created by wang lei
  清除格式页面
 *
 */
import React, {Component} from 'react';
import clearFormat from './clearFormat.png';
import {EDITOR_TOOL_BTN_COLOR} from "../../../../../constants";

export default class ClearFormatTool extends Component {
   constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        return (
            <span style={{cursor:"pointer"}} onClick={()=>{
                this.props.editor.execCommand( 'removeFormat', 'strong,em,sub,sup' )
            }}>
                <img className={"editor-clear-format-tool-btn"} src={clearFormat}/>
                <style>{`
                    .editor-clear-format-tool-btn{
                        border: 1px solid #f2f6fc
                    }
                    .editor-clear-format-tool-btn:hover{
                        border: 1px solid ${EDITOR_TOOL_BTN_COLOR.hover}
                    }
                    .editor-clear-format-tool-btn:active{
                        border: 1px solid ${EDITOR_TOOL_BTN_COLOR.press}
                    }
                `}</style>
            </span>
        )
    }

}